function Checkbox({ value, name, label, onChange, checked }) {

  const handleChecked = (event) => {
    const { name, checked } = event.target
    onChange({ name, value, checked })
  }

  return (
    <div className="form-check">
      <input
        id={'id-checkbox-' + value}
        className="form-check-input"
        type="checkbox"
        name={name}
        value={value}
        onChange={handleChecked}
        checked={checked}
      />
      <label htmlFor={'id-checkbox-' + value} className="form-check-label">{label}</label>
    </div>
  )
}

export default Checkbox;
